export default "__VITE_ASSET__032a5315__"